module.exports = __webpack_public_path__ + "d9083cf866b48fc05321df8e1f6ff509.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-bold.eot
// module id = 27
// module chunks = 0